import { URL } from './endpoints'
import { submitToApi } from 'awsApi'

export const ACTIONS = {
    GET_RATINGS: {
        START: 'GET_RATINGS START',
        SUCCESS: 'GET_RATINGS SUCCESS',
        FAILURE: 'GET_RATINGS FAILURE',
    },
    POST_RATING: {
        START: 'POST_RATING START',
        SUCCESS: 'POST_RATING SUCCESS',
        FAILURE: 'POST_RATING FAILURE',
    },
}

export const getRatings = () => async dispatch => {
    dispatch({ type: ACTIONS.GET_RATINGS.START })
    try {
        const { payload } = await submitToApi({
            path: URL.RATINGS.V3_RATINGS_USER_RETRIEVE,
            url: URL.RATINGS.BASE,
        })
        dispatch({ type: ACTIONS.GET_RATINGS.SUCCESS, data: payload.data })
    } catch (error) {
        dispatch({ type: ACTIONS.GET_RATINGS.FAILURE, error })
    }
}

export const postRating = body => async dispatch => {
    dispatch({ type: ACTIONS.POST_RATING.START })
    try {
        await submitToApi({
            body,
            method: 'POST',
            path: URL.RATINGS.V3_RATINGS_USER_SUBMIT,
            url: URL.RATINGS.BASE,
        })
        dispatch({ type: ACTIONS.POST_RATING.SUCCESS })
    } catch (error) {
        dispatch({ type: ACTIONS.POST_RATING.FAILURE, error })
    }
}
